(() => {
    var FileUploadComponent = Vue.extend({
        name: 'file-upload',
        template: `
<div v-bind:class="className">
    <label class="fileContainer" @dragover.prevent @drop="_onDropFiles">
        <div><i class="fa fa-cloud-upload fa-3x"></i></div>
        <span>Select files or drop them over to upload</span><br/><span>Or press CTRL+V</span>
        <input type="file" v-bind:name="name" v-bind:id="id || name" v-bind:accept="accept" v-on:click="fileInputClick" v-on:change="fileInputChange" v-bind:multiple="multiple">
        <slot></slot>
    </label>
        <div class="progress" data-progress="0">
            <div class="progress_mask isFull">
                <div class="progress_fill"></div>
            </div>
            <div class="progress_mask">
                <div class="progress_fill"></div>
            </div>
        </div>
    </div>
</div>
        `,
        props: {
            className: String,
            name: {
                type: String,
                required: true
            },
            id: String,
            action: {
                type: String,
                required: true
            },
            accept: String,
            multiple: String,
            headers: Object,
            method: String,
            buttonText: {
                type: String,
                default: 'Upload'
            },
            // xhr: null
        },
        data: function () {
            return {
                myFiles: [],
                xhr: null
            };
        },
        methods: {
            fileInputClick: function () {
                // console.log('fileInputClick');
                this.$emit('onFileClick', this.myFiles);
            },
            fileInputChange: function () {
                // console.log('fileInputChange');
                var ident = this.id || this.name
                this.myFiles = document.getElementById(ident).files;
                this.$emit('onFileChange', this.myFiles);
                // console.log(this.myFiles);
                this.fileUpload();
            },
            _onProgress: function (e) {
                e.percent = (e.loaded / e.total) * 100;
                this.$emit('onFileProgress', e);
                // console.log('onFileProgress', e);
                this.$parent.uploadProgress(e);
            },
            _handleUpload: function (files) {
                this.$emit('beforeFileUpload', files);
                var form = new FormData();
                this.xhr = new XMLHttpRequest();
                form.append('token', 'carocetoken');
                for (let i in files) {
                    try {
                        // form.append('Content-Type', files.type || 'application/octet-stream');
                        form.append('file', files[i]);
                    } catch (err) {
                        this.$emit('onFileError', files, err);
                        return;
                    }
                }
                let that = this;
                return new Promise(function (resolve, reject) {

                    that.xhr.upload.addEventListener('progress', this._onProgress, false);

                    that.xhr.onreadystatechange = function () {
                        if (that.xhr.readyState < 4) {
                            return;
                        }
                        if (that.xhr.status < 400) {
                            var res = JSON.parse(that.xhr.responseText);
                            this.$parent.filesUploaded(files, res);
                            resolve(files);
                        } else {
                            var err = JSON.parse(that.xhr.responseText);
                            err.status = that.xhr.status;
                            err.statusText = that.xhr.statusText;
                            this.$emit('onFileError', files, err);
                            reject(err);
                        }
                    }.bind(this);

                    that.xhr.onerror = function () {
                        var err = JSON.parse(that.xhr.responseText);
                        err.status = that.xhr.status;
                        err.statusText = that.xhr.statusText;
                        this.$emit('onFileError', files, err);
                        reject(err);
                    }.bind(this);

                    that.xhr.open("POST", 'https://static.md/api/v4/upload', true);
                    that.xhr.send(form);
                    this.$emit('afterFileUpload', files);
                }.bind(this));
            },
            fileUpload: function () {
                if (this.myFiles.length > 0) {
                    return this._handleUpload(this.myFiles)
                        .then(function (allFiles) {}.bind(this)).catch(function (err) {
                            this.$emit('onFileError', this.myFiles, err);
                        }.bind(this));
                } else {
                    var err = new Error("No files to upload for this field");
                    this.$emit('onFileError', this.myFiles, err);
                }
            },
            _onDropFiles: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.myFiles = e.dataTransfer.files;
                this.fileUpload();
            },
            abortUpload: function () {
                if (this.xhr) {
                    this.xhr.abort();
                };
            },
            pasteDropImages: function (images) {
                this.myFiles = images;
                this.fileUpload();
            }
        }
    });

    Vue.component('file-upload', FileUploadComponent);
    // console.log('init FileUploadComponent');
})();
 (() => {
   let UploadModalComponent = Vue.extend({
     name: 'uploadmodal',
     template: `
<transition name="modal">
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
      <!--
        <div class="modal-header modal-title">
          <slot name="header">Choose local file</slot>
        </div>
        -->
        <div class="modal-body">
          <file-upload className="my-file-uploader" name="myFile" id="myCustomId" action="upload.php" multiple></file-upload>
          <slot name="body">
          </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button @click="closeModal" class="modal-default-button">Cancel</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</transition>`,
     methods: {
       filesUploaded: function (data, res) {
         this.$parent.filesUploaded(data, res);
       },
       uploadProgress: function (e) {
         var progress = document.getElementsByClassName('progress')[0];
         var dropZone = document.getElementsByClassName('fileContainer')[0];

         progress.style.display = 'block';
         dropZone.style.display = 'none';
         progress.setAttribute('data-progress', Math.floor(e.percent));
       },
       closeModal: function (е) {
         this.$emit('close');

         this.$children[0].abortUpload();
       },
     },
     data: function () {
       return {
         pasteDropImages: function (images) {
           this.$children[0].pasteDropImages(images);
         },
         modalBackdrop: function() {
           this.closeModal();
         }
       }
     }
   });
   Vue.component('uploadmodal', UploadModalComponent);
   //  console.log('init UploadModalComponent');
 })();
$(document).ready(() => {
	let uploadOv = document.createElement('div');
	let uploadOvZ = document.createElement('div');
	let uploadOvH1 = document.createElement('h1');
	uploadOv.classList.add('upload-overlay');
	uploadOvZ.classList.add('upload-overlay-zone');
	uploadOvH1.textContent = 'Drop Here';
	uploadOvZ.appendChild(uploadOvH1);
	uploadOv.appendChild(uploadOvZ);
	document.body.appendChild(uploadOv);
	// Promise polyfill
	if (!window.Promise)
		window.Promise = Promise;

	let galleryIdGl;

	i18next.init({
		lng: 'en',
		resources: {
			en: {
				translation: {
					nav: {
						'home': 'Home',
						'gallery': 'Gallery',
						'contact': 'Contact',
						'API': 'API',
						'upload': 'Upload',
						'privacypolicy': 'Terms & Privacy Policy'
					},
					home: {
						'hello': 'Hello',
						'description': 'Free image hosting',
					}
				}
			}
		}
	}, (err, t) => {
		// console.log(err, t);
		// console.log('i18n ready');
		jqueryI18next.init(i18next, $);
	});

	// Animate loaded content
	let waypoints = [];

	function showContent() {
		document.getElementsByClassName('header')[0].classList.add('animated', 'fadeIn');
		document.getElementsByClassName('headline')[0].classList.add('animated', 'fadeInUp');
		document.getElementsByClassName('footer')[0].classList.add('animated', 'fadeIn');
		document.getElementsByClassName('footer')[0].style.visibility = 'visible';
		document.getElementById('app').style.visibility = 'visible';

		let sections = document.getElementsByClassName('section');
		for (let i = 0; i < sections.length; i++) {
			waypoints[i] = new Waypoint({
				element: sections[i],
				offset: '100%',
				handler: () => {
					sections[i].getElementsByClassName('section__name')[0].classList.add('animated', 'fadeInLeft');
					sections[i].getElementsByClassName('section__list')[0].classList.add('animated', 'fadeInRight');
				}
			});
		}
		$('body').localize();
	}

	// Wait for the primary font to load
	let font = new FontFaceObserver('Titillium Web').load()
		.then(function () {
			// console.log('Font is available');
		}, function () {
			// console.log('Font is not available');
		});

	// Load and change page content
	function changePage(name) {
		// Hide old content
		return new Promise((resolve, reject) => {
			document.getElementsByClassName('footer')[0].style.visibility = 'hidden';
			document.getElementById('app').style.visibility = 'hidden';
			window.scrollTo(0, 0);

			// Change navigation active link
			let nav = document.getElementsByClassName('header__nav__link');
			for (let i = 0; i < nav.length; i++)
				nav[i].classList.remove('header__nav__link--active');
			let active = document.getElementById('nav_' + name);
			if (active)
				active.classList.add('header__nav__link--active');

			// Change page title
			let title = name.toLowerCase().replace(/\b[a-z]/g, function (letter) {
				return letter.toUpperCase();
			});
			document.title = title + ' | Static MD';

			// Send pageview to google analytics
			ga('set', {
				page: location.pathname,
				title: title
			});
			ga('send', 'pageview');

			// Destroy old waypoints
			for (let i = 0; i < waypoints.length; i++)
				waypoints[i].destroy();

			// Fetch new content
			let page = axios.get('/layout_' + name + '.html');

			// When both font and content are properly loaded, show the content
			Promise.all([font, page]).then(res => {
				document.documentElement.classList.add('fonts-loaded');
				document.getElementById('app').innerHTML = res[1].data;
				showContent();
				router.updatePageLinks();
				return;
				// window.initApp ? window.initApp() : null;
			}).then(() => {
				resolve()
			})
		})
	}

	// Initializes and opens PhotoSwipe
	function initPhotoSwipeFromDOM(gallerySelector) {
		// parse slide data (url, title, size ...) from DOM elements 
		// (children of gallerySelector)
		var parseThumbnailElements = function (el) {
			// use only the grid items with images, ignoring the .grid-sizer
			// and .gutter-sizer elements
			var thumbElements = Array.from(el.childNodes),
				numNodes = thumbElements.length,
				items = [],
				figureEl,
				linkEl,
				size,
				item;

			for (var i = 0; i < numNodes; i++) {
				figureEl = thumbElements[i]; // <figure> element

				// console.log('hhhhhhhhhhhhhhh', figureEl)
				// include only element nodes 
				if (figureEl.nodeType !== 1) {
					continue;
				}

				linkEl = figureEl.children[0]; // <a> element
				if (!linkEl)
					continue;
				size = linkEl.getAttribute('data-size').split('x');

				// create slide object
				item = {
					src: linkEl.getAttribute('href'),
					w: parseInt(size[0], 10),
					h: parseInt(size[1], 10)
				};

				if (figureEl.children.length > 1) {
					// <figcaption> content
					item.title = figureEl.children[1].innerHTML;
				}

				if (linkEl.children.length > 0) {
					// <img> thumbnail element, retrieving thumbnail url
					item.msrc = linkEl.children[0].getAttribute('src');
				}

				item.el = figureEl; // save link to element for getThumbBoundsFn
				items.push(item);
			}

			return items;
		};

		// find nearest parent element
		var closest = function closest(el, fn) {
			return el && (fn(el) ? el : closest(el.parentNode, fn));
		};

		// triggers when user clicks on thumbnail
		var onThumbnailsClick = function (e) {
			e = e || window.event;
			e.preventDefault ? e.preventDefault() : e.returnValue = false;

			var eTarget = e.target || e.srcElement;

			// find root element of slide
			var clickedListItem = closest(eTarget, function (el) {
				return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
			});

			if (!clickedListItem) {
				return;
			}
			// console.log(clickedListItem);
			// find index of clicked item by looping through all child nodes
			// alternatively, you may define index via data- attribute
			var clickedGallery = clickedListItem.parentNode,
				childNodes = clickedListItem.parentNode.childNodes,
				numChildNodes = childNodes.length,
				nodeIndex = 0,
				index;
			// console.log(clickedGallery);
			for (var i = 0; i < numChildNodes; i++) {
				if (childNodes[i].nodeType !== 1) {
					continue;
				}

				if (childNodes[i] === clickedListItem) {
					index = nodeIndex;
					break;
				}
				nodeIndex++;
			}
			// console.log(index - 2);
			if (index >= 0) {
				// open PhotoSwipe if valid index found
				// index -2 is used to ignore the .grid-sizer and .gutter-sizer elements
				openPhotoSwipe(index - 2, clickedGallery);
			}
			return false;
		};

		// parse picture index and gallery index from URL (#&pid=1&gid=2)
		var photoswipeParseHash = function () {
			var hash = window.location.hash.substring(1),
				params = {};

			if (hash.length < 5) {
				return params;
			}

			var vars = hash.split('&');
			for (var i = 0; i < vars.length; i++) {
				if (!vars[i]) {
					continue;
				}
				var pair = vars[i].split('=');
				if (pair.length < 2) {
					continue;
				}
				params[pair[0]] = pair[1];
			}

			if (params.gid) {
				params.gid = parseInt(params.gid, 10);
			}

			return params;
		};

		var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
			var pswpElement = document.querySelectorAll('.pswp')[0],
				gallery,
				options,
				items;

			items = parseThumbnailElements(galleryElement);

			// define options (if needed)
			options = {

				// define gallery index (for URL)
				galleryUID: galleryElement.getAttribute('data-pswp-uid'),

				getThumbBoundsFn: function (index) {
					// See Options -> getThumbBoundsFn section of documentation for more info
					var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
						pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
						rect = thumbnail.getBoundingClientRect();

					return {
						x: rect.left,
						y: rect.top + pageYScroll,
						w: rect.width
					};
				},
				zoomEl: true,
				preloaderEl: true
			};

			// PhotoSwipe opened from URL
			if (fromURL) {
				if (options.galleryPIDs) {
					// parse real index when custom PIDs are used 
					// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
					for (var j = 0; j < items.length; j++) {
						if (items[j].pid == index) {
							options.index = j;
							break;
						}
					}
				} else {
					// in URL indexes start from 1
					options.index = parseInt(index, 10) - 1;
				}
			} else {
				options.index = parseInt(index, 10);
				// console.log(options.index);
			}

			// exit if index not found
			if (isNaN(options.index)) {
				return;
			}

			if (disableAnimation) {
				options.showAnimationDuration = 0;
			}
			// console.log(items);
			// Pass data to PhotoSwipe and initialize it
			gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
			gallery.init();
		};

		// loop through all gallery elements and bind events
		var galleryElements = document.querySelectorAll(gallerySelector);

		for (var i = 0, l = galleryElements.length; i < l; i++) {
			galleryElements[i].setAttribute('data-pswp-uid', i + 1);
			galleryElements[i].onclick = onThumbnailsClick;
		}

		// Parse URL and open gallery if it contains #&pid=3&gid=1
		var hashData = photoswipeParseHash();
		if (hashData.pid && hashData.gid) {
			openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
		}
	}

	function handleEmbedMenu(imagesList) {
		var $modal = $('#embedModal');

		// Get the button that opens the modal
		var $btn = $("#embedModalTrigger");

		// Get the <span> element that closes the modal
		var $close = $(".close");

		var $embedBtns = $('.embed-btn');
		var $inputs = $('.input-field input');
		var $copyTrigger = $('.copy-trigger');
		// var link = window.location.href;
		var link = `${window.location.host}/${galleryIdGl}`;

		var htmlCode = '';
		var bbCode = ``;
		var linksCode = '';

		for (var i = 0; i < imagesList.length; i++) {
			htmlCode += `<a href="${imagesList[i].url}"><img src="${imagesList[i].url}" border="0" />static.md</a>\n`;
			bbCode += `[url=${imagesList[i].url}][img]${imagesList[i].url}[/img][/url]\n`;
			linksCode += imagesList[i].url + '\n';
		};

		embedForm.embedCode.value = htmlCode;

		// When the user clicks the button, open the modal 
		$btn.on('click', (e) => {
			$modal.css('display', 'block');
			embedForm.embedLink.value = link;
		});

		// When the user clicks on close the modal
		$close.on('click', () => {
			$modal.css('display', 'none');
		});

		$($embedBtns).on('click', function (e) {
			$($embedBtns).removeClass('selected');
			$(this).addClass('selected');

			if ($(e.target).hasClass('embedHTML')) {
				embedForm.embedCode.value = htmlCode;
			} else if ($(e.target).hasClass('embedBB')) {
				embedForm.embedCode.value = bbCode;
			} else if ($(e.target).hasClass('embedLinks')) {
				embedForm.embedCode.value = linksCode;
			};
		});

		$($inputs).on('click', function (e) {
			var $tooltip = $(this).next('.tooltip');
			$(this).select();
			document.execCommand('copy');
			$tooltip.addClass('visible');
			setTimeout(() => {
				$tooltip.removeClass('visible');
			}, 1500);
		});

		$($copyTrigger).on('click', function (e) {
			$(embedForm.embedCode).select();
			var $tooltip = $(embedForm.embedCode).next('.tooltip');
			document.execCommand('copy');
			$tooltip.addClass('visible');
			setTimeout(() => {
				$tooltip.removeClass('visible');
			}, 1500);
		});

		// When the user clicks anywhere outside of the modal, close it
		window.onclick = function (e) {
			if ($(e.target).hasClass('modal')) {
				$modal.css('display', 'none');
			};
		};
	};

	function initMasonryScrollReveal(elem, gridItems) {
		var totalItems = gridItems.length;
		var msnry = new Masonry(elem, {
			// Masonry grid options
			itemSelector: '.grid-item',
			columnWidth: '.grid-sizer',
			percentPosition: true,
			gutter: '.gutter-sizer',
			horizontalOrder: true,
			transitionDuration: '0.2s'
		});

		if (totalItems < 3) {
			var styleTemplate = `
			<style>
				.grid-sizer, .grid-item {
					width: 100%;
				}
				@media (min-width: 500px) {
					.grid-sizer, .grid-item {
						width: ${100 / totalItems}%;
					}
				}
			</style>
			`;

			$('.content-section').append(styleTemplate);
		};

		window.sr = ScrollReveal({
			// reset: true,
			useDelay: 'onload',
			viewport: document.getElementById('#grid'),
		});
		sr.reveal('.grid-item');

		imagesLoaded(elem).on('progress', function (instance, image) {
			// layout Masonry after images load one-by-one
			msnry.layout();
		});
	};

	function showToast($toast) {
		$toast.addClass('show');
		setTimeout(function () {
			$toast.removeClass('show');
		}, 3000);
	};

	// Navigo router
	window.router = new Navigo(location.protocol + '//' + location.host, false);
	window.router.notFound(() => {
			// console.log('change to 404');
			router.navigate('/g/bLu2Kv');
		})
		.on({
			'/contact': () => {
				// console.log('change to contact');
				changePage('contact');
			},
			'/privacy': () => {
				// console.log('change to privacy');
				changePage('privacy');
			},
			'/developer': () => {
				// console.log('change to developer');
				changePage('developer');
			},
			'/404': () => {
				// console.log('change to 404');
				changePage('404');
			},
			'/g/:galleryId': (params) => {
				// console.log('change to gallery');
				// console.log(params);
				galleryIdGl = params.galleryId;
				changePage('gallery')
					.then(() => {
						var elem = document.getElementById('grid');

						var newPics = '';
						var requestGallery = $.ajax({
							type: 'GET',
							url: `https://static.md/api/v4/g/${params.galleryId}`,
							dataType: 'json'
						});

						requestGallery
							.done((galleryData) => {
								galleryData.links.forEach((image) => {
									newPics += `
								<figure class="grid-item" itemprop="associatedMedia" itemscope="itemscope" itemtype="http://schema.org/ImageObject" id="outer-box">
									<a href="${image.url}" itemprop="contentUrl" data-size="${image.size.w}x${image.size.h}">
									<img src="${image.url}" itemprop="thumbnail" alt="Image description"/>
									<div id="inner-box">
										<p class="center-icon"><i class="fa fa-search fa-lg"></i></p>
										<p class="bottom-icon share-link-trigger"><i class="fa fa-share-alt"></i></p>
										<div class="share-link-wrapper">
											<input type="text" class="img-share-link" value="${image.url}" readonly="true"/>
										</div>
									</div>
									</a>
									<!-- <figcaption itemprop="caption description"></figcaption> -->
								</figure>`;
								});

								handleEmbedMenu(galleryData.links);
								return galleryData.links;
							})
							.then((galleryLinks) => {
								elem.innerHTML += newPics;

								initMasonryScrollReveal(elem, galleryLinks.links);

								// initialize PhotoSwipe using existing images
								initPhotoSwipeFromDOM('.grid-gallery');


								var $shareLinkTrigger = $('.share-link-trigger');
								$shareLinkTrigger.on('click', function (e) {
									var $linkWrapper = $(this).next('.share-link-wrapper');
									e.preventDefault();

									$linkWrapper.find('.img-share-link').on('blur', function () {
										$shareLinkTrigger.next().removeClass('visible');
									});

									$linkWrapper.toggleClass('visible');

									$linkWrapper.find('.img-share-link').focus().select();
									document.execCommand('copy');

									showToast($('#toast'));

									return false;
								});
							})
							.fail((error) => {
								// console.log(error);
								if (error.status == 404) {
									window.router.navigate('404');
								}
							});
					});
			}
		})
		.on(() => {
			// console.log('change to home');
			changePage('home');
		})
		.resolve();
});
/*! pace 1.0.0 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e,f;f=[];for(d in b.prototype)try{e=b.prototype[d],f.push(null==a[d]&&"function"!=typeof e?a[d]=e:void 0)}catch(g){c=g}return f},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);
$(document).ready(() => {
    window.initApp = () => {
        var uploadApp = new Vue({
            el: '#uploadApp',
            data: {
                showModal: false,
                pasteDropImages: function (images) {
                    setTimeout(() => {
                        this.$children[0].pasteDropImages(images);
                    }, 100);
                }
            },
            methods: {
                filesUploaded: (data, res) => {
                    window.router.navigate('/g/' + res.gallery);
                    headerApp.toggleModal(new Event(null));
                }
            }
        });
        var headerApp = new Vue({
            el: '#headerApp',
            data: {
                toggleModal: (e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    uploadApp.showModal = !uploadApp.showModal;
                    if (!uploadApp.showModal) {
                        uploadApp.$children[0].modalBackdrop();
                    };
                }
            }
        });
        // console.log('vue init');
        // console.log('uploadApp', uploadApp);
        // console.log('headerApp', headerApp);
        document.addEventListener('paste', (e) => {
            for (var i = 0; i < e.clipboardData.items.length; i++) {
                var item = e.clipboardData.items[i];
                if (item.type.indexOf('image') != -1) {
                    uploadApp.showModal = true;
                    uploadApp.pasteDropImages([item.getAsFile()]);
                } else {
                    console.log('Discarding image paste data. Not an image.');
                };
            };
        });

        var uploadLink = document.querySelector('.upload-overlay');
        var withinEnter = false;

        document.addEventListener('dragenter', (e) => {
            e.preventDefault();
            e.stopPropagation();

            setTimeout(function () {
                uploadLink.classList.add('show');
                uploadApp.showModal = false;
            }, 0);
        });

        // Prevent browser's default behaviour
        document.addEventListener('dragover', (e) => {
            e.preventDefault();
            e.stopPropagation();
        });

        document.body.addEventListener('dragleave', (e) => {
            e.preventDefault();
            e.stopPropagation();
            uploadLink.classList.remove('show');
        });

        document.addEventListener('drop', (e) => {
            e.preventDefault();
            e.stopPropagation();
            ga('send', 'event', 'Homepage', 'Drop');
            document.querySelector('.upload-overlay').classList.remove('show');

            // If dropped items aren't files, reject them
            var dt = e.dataTransfer;
            var files = [];
            if (dt.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < dt.items.length; i++) {
                    if (dt.items[i].kind == 'file') {
                        var file = dt.items[i].getAsFile();
                        files.push(file);
                    };
                };
            } else {
                // Use DataTransfer interface to access the file(s)
                for (var i = 0; i < dt.files.length; i++) {
                    var file = dt.files[i];
                    files.push(file);
                };
            };

            uploadApp.showModal = true;
            uploadApp.pasteDropImages(files);
        });
        // Cleanup drag items
        document.addEventListener('dragend', (e) => {
            document.querySelector('.upload-overlay').classList.remove('show');
            // console.log('dragend');
            var dt = e.dataTransfer;
            if (dt.items) {
                // Use DataTransferItemList interface to remove the drag data
                for (var i = 0; i < dt.items.length; i++) {
                    dt.items.remove(i);
                };
            } else {
                // Use DataTransfer interface to remove the drag data
                e.dataTransfer.clearData();
            };

            uploadLink.classList.remove('upload-fancy');
        });

        // When the user clicks anywhere outside of the modal, close it
		window.onclick = function (e) {
			if ($(e.target).hasClass('modal-wrapper')) {
                headerApp.toggleModal(new Event(null));
			};
		};
    };
    window.initApp();
});